import { createFileRoute } from '@tanstack/react-router'

import { TechnicalError } from '@orus.eu/error'
import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PlatformSearchPage } from '../../../components/pages/backoffice/platform/platform-search-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'
import { useBackofficeUser } from '../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/search')({
  component: function Component() {
    const backofficeUser = useBackofficeUser()

    if (!backofficeUser) {
      throw new TechnicalError('There should have been a backoffice user at this point')
    }

    return (
      <PermissionChecker requiredPermissions={[anyOfPermissions('search', 'search.relatedOnly', 'search.allowedOnly')]}>
        <PlatformSearchPage />
      </PermissionChecker>
    )
  },
})
